import type { PropsWithChildren } from 'react';
import './DetailsSection.css';

interface Props {
    title: string;
    count?: number;
    defaultOpen?: boolean;
}

export default function DetailsSection({
    title,
    count,
    defaultOpen = false,
    children,
}: PropsWithChildren<Props>) {
    return (
        <details className="details-section" open={defaultOpen}>
            <summary className="details-section__summary">
                <span className="details-section__title">{title}</span>
                {count !== undefined && (
                    <span className="details-section__count" aria-hidden="true">
                        {count}
                    </span>
                )}
                <span className="details-section__chevron" aria-hidden="true">
                    ▸
                </span>
            </summary>
            <div className="details-section__body">{children}</div>
        </details>
    );
}
